import React from 'react';

const TaxableDetailsList = (props) => {
// console.log('Taxable Details: ', props)
  return (
    <div>Stuff</div>
  )
}

export default TaxableDetailsList